<template>
    <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
        <button
            class="navbar-toggler d-lg-none"
            type="button"
            data-toggle="collapse"
            data-target="#navbar"
            aria-controls="navbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <span class="navbar-toggler-icon" />
        </button>

        <a class="navbar-brand text-muted" :href="home">
            <img
                src="/logo.jpg"
                width="30"
                height="30"
                class="d-inline-block align-top"
                alt=""
            />
        </a>

        <div id="navbar" class="collapse navbar-collapse">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <router-link
                        to="/"
                        active-class="active"
                        class="nav-link"
                        exact
                        >Overview</router-link
                    >
                </li>
                <li class="nav-item">
                    <router-link
                        to="/user"
                        active-class="active"
                        class="nav-link"
                        exact
                        >Create Proxies</router-link
                    >
                </li>
                <li class="nav-item">
                    <router-link
                        to="/export"
                        active-class="active"
                        class="nav-link"
                        exact
                        >Export Proxies</router-link
                    >
                </li>
                <li class="nav-item">
                    <router-link
                        to="/ip"
                        active-class="active"
                        class="nav-link"
                        exact
                        >IP Authorization</router-link
                    >
                </li>
                <li class="nav-item">
                    <router-link
                        to="/setting"
                        active-class="active"
                        class="nav-link"
                        exact
                        >Setting</router-link
                    >
                </li>
                <li class="nav-item">
                    <router-link
                        to="/billing"
                        active-class="active"
                        class="nav-link"
                        exact
                        >Billing</router-link
                    >
                </li>
            </ul>
            <form class="form-inline mt-2 mt-md-0">
                <button
                    class="btn btn-outline-secondary my-2 my-sm-0"
                    @click.prevent="logout"
                >
                    Logout
                </button>
            </form>
        </div>
    </nav>
</template>

<script>
import { config, auth, response } from 'website-core'

export default {
    data() {
        return {
            home: config.url,
        }
    },
    methods: {
        async logout() {
            await auth.logout()
            this.$router.push('/sign-in')
        },
    },
}
</script>